/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _isControlledValue = _interopRequireDefault(require("./isControlledValue"));
var _default = function _default(props, propName) {
  if (!props) {
    return false;
  }
  return (0, _isControlledValue.default)(props[propName]);
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/utils/isControlledProperty.js
// module id = 115
// module chunks = 0